import * as React from 'react';
import { Button } from '@cian/ui-kit';
import { IconProductDateTime16 } from '@cian/ui-kit-design-tokens/icons';

export interface IFlatViewOrderButtonProps {
  disabled?: boolean;
  onClick(e: React.MouseEvent<HTMLElement>): void;
}

export function FlatViewOrderButton({ onClick, disabled }: IFlatViewOrderButtonProps) {
  return (
    <Button
      theme="stroke_primary"
      size="M"
      onClick={onClick}
      disabled={disabled}
      beforeIcon={<IconProductDateTime16 color="current_color" />}
    >
      Записаться на просмотр
    </Button>
  );
}
